exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-3917ef42] .adp-dd-options {\n  max-width: 310px;\n  min-width: 310px;\n  left: 0;\n}\n[data-v-3917ef42] .arrow-icon {\n  margin-left: 7px;\n  transform: rotate(90deg);\n}\n", ""]);

// exports
